import React, { useState, useEffect } from "react";
import { Form, Field } from "react-final-form";
import DatePicker from "react-datepicker";
import { Redirect } from "react-router-dom";

import {
  FORM_FIELDS_USER_ONE,
  API_URL,
  POST_USER_REGISTER_TYPE_ONE,
  GET_COUNTRIES,
  CONTINENTS,
  POST_USER_EMAIL_EXIST
} from "../../../constants";
import { CHECK_IF_REQUIRED, OBJECT_EMPTY, EMAIL_VALIDATION } from "../../../helpers";

import { RegisterEmailComponent } from "../RegisterEmailComponent";
import { RegisterProductDescriptionComponent } from "./RegisterProductDescriptionComponent";

import "react-datepicker/dist/react-datepicker.css";
import "../RegisterCountrySelect.css";

export const RegisterUserType1 = (props) => {
  // Potential form states FORM, SUCCESS, FAILURE

  const [currentStep, setCurrentStep] = useState(1);
  // const [isRegistrationError, setRegistrationError] = useState(false);
  const [, setRegistrationError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  // const [countriesLoaded, setCountriesLoaded] = useState(false);
  // const [formFinished, setformFinished] = useState(false);
  const [emailIsValid, setEmailIsValid] = useState(null);
  const [companyNameIsValid, setCompanyNameIsValid] = useState(null);
  const [currentContinent, setCurrentCountry] = useState("EUR");
  // const [moss, setMoss] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [selectedCountries, setSelectedCountries] = useState({});
  const [countries, setCountries] = useState({});
  const [emailErrorMessage, setEmailErrorMessage] = useState('');
  const [emailToTest, setEmailToTest] = useState('');
  const [companyNameToTest, setCompanyNameToTest] = useState('');
  const [differentEmailToTest, setDifferentEmailToTest] = useState('');
  const [datesSubmitDisabled, setDatesSubmitDisabled] = useState(true);


  // GET countries
  useEffect(() => {
    if (OBJECT_EMPTY(countries)) {
      fetch(API_URL + GET_COUNTRIES)
        .then((response) => response.json())
        .then((data) => setCountries(data));
    }
  // eslint-disable-next-line
  }, []);

  // GET POST_USER_EMAIL_EXIST
  useEffect(() => {
    if (currentStep === 2) {
      fetch(API_URL + POST_USER_EMAIL_EXIST, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: emailToTest
        }),
      })
      .then((res) => res.json())
      .then((res) => {
        if (res.length === 0) {
          currentStep === 2 && moveStepUp();
        } else {
          currentStep === 2 && setCurrentStep(1);
          setEmailErrorMessage(res.email)
        }
      });
    }
  // eslint-disable-next-line
  }, [currentStep]);

  useEffect(() => {
    setDatesSubmitDisabled(false);

    Object.entries(selectedCountries).map(([, value]) => {
      if (value.dates.startdate === null || value.dates.startdate === "") {
        return setDatesSubmitDisabled(true)
      }
    });
  }, [selectedCountries])

  const moveStepUp = () => {
    setCurrentStep(currentStep + 1);
  };

  const onSubmit = async (values) => {
    const countries = [];

    Object.entries(selectedCountries).map(
      ([currentCountry, currentCountryValue]) => {
        return countries.push(currentCountryValue);
      }
    );

    setIsLoading(true);

    await fetch(API_URL + POST_USER_REGISTER_TYPE_ONE, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        ...values,
        countries: countries,
      }),
    })
    .then((response) => {
      if (response.status === 201) {
        return response.json()
      } else {
        console.log("error", response);
        setIsLoading(false);
        setRegistrationError(true);
      }
    }).then((response) => {
      console.log(response) // for using it for name

      if (response !== undefined) {
        setIsLoading(false);
        props.initiateRealLogIn(response.access_token)
          .then(() => currentStep === 3 && true && setCurrentStep(4))

        // currentStep === 3 && true && setCurrentStep(4);
      }
    })
  };

  // 1st step
  const setEmailError = () => setEmailIsValid(false);
  const setCompanyNameError = () => setCompanyNameIsValid(false);
  const removeEmailError = () => setEmailIsValid(null);
  const removeCompanyNameError = () => setCompanyNameIsValid(null);

  const setCurrentContinentSibling = (e, continent) => {
    const sibling =
      e.target.nodeName === "SPAN"
        ? e.target.parentNode.previousSibling
        : e.target.previousSibling;
    const existingSibling = document.querySelector("[sibling='true']");

    return [
      existingSibling && existingSibling.setAttribute("sibling", "false"),
      sibling && sibling.setAttribute("sibling", "true"),
      setCurrentCountry(continent),
    ];
  };

  const mossCheckbox = () => {
    return (
      <label>
        <Field
          name="EUR"
          component="input"
          type="checkbox"
          value="moss"
          imgurl='moss'
          onClick={(e) => checkboxOnClick(e)}
        />
        <div className="icon moss"></div>
        Oss
      </label>
    );
  };

  const getCountries = () => {
    let mossExists = currentContinent === "EUR";

    return countries[currentContinent].map((item, index) => {
      return (
        <div className="country-select" key={index}>
          {index === 0 && mossExists && mossCheckbox()}

          {/* <label className={mossExists ? "disabled-input" : ""}> */}
          <label>
            <Field
              name={currentContinent}
              component="input"
              type="checkbox"
              imgurl={item.img}
              value={item.name}
              // disabled={mossExists ? true : false}
              onClick={(e) => checkboxOnClick(e)}
            />
            {item.name}
          </label>
        </div>
      );
    });
  };

  const getContinents = (values) => {
    return Object.entries(countries).map(([continent]) => {
      return (
        <div
          className={
            "country-row " +
            ((currentContinent === continent && "tab-active ") || "")
          }
          key={continent}
          sibling="false"
          onClick={(e) => {
            setCurrentContinentSibling(e, continent);
          }}
        >
          <div className={'logo ' + continent}></div>
          {CONTINENTS[continent]}

          {values[continent] ? (
            values[continent].length > 0 ? (
              <span className="count">{values[continent].length}</span>
            ) : (
              ""
            )
          ) : (
            ""
          )}
        </div>
      );
    });
  };

  const checkboxOnClick = (obj) => {

    if (obj.target.checked) {
      return setSelectedCountries({
        ...selectedCountries,
        [obj.target.value]: {
          continent: obj.target.name,
          country: obj.target.value.toString(),
          img: obj.target.getAttribute('imgurl'),
          dates: {
            startdate: null,
            enddate: null,
          },
        },
      });
    } else {
      let previousCountriesObject = selectedCountries;
      delete previousCountriesObject[obj.target.value];

      setSelectedCountries(previousCountriesObject);
    }
  };

  const setDate = (newDate, countryItem, dateType) => {
    setSelectedCountries({
      ...selectedCountries,
      [countryItem]: {
        ...selectedCountries[countryItem],
        dates: {
          ...selectedCountries[countryItem]["dates"],
          [dateType]: newDate,
        },
      },
    });
  };

  const listSelectedCountriesModal = () => {
    return Object.entries(selectedCountries).map(([currentCountry, itemValues]) => {
      const countryItem = currentCountry;
  
      return (
        <tr className="date-item" key={countryItem}>
          <td className="date-item__name flex-align-center">
            {
              itemValues.img === 'moss'
              ? <div className="icon moss"></div>
              : <img src={itemValues.img} className="flag-icon-img" alt={countryItem}/>
            }

            {countryItem === "moss"? "oss" : countryItem }
          </td>
          <td>
            {/* https://github.com/Hacker0x01/react-datepicker/issues/1757 */}
            <DatePicker
              dateFormat="yyyy-MM-dd"
              autoComplete="off"
              name={"startdate_" + countryItem}
              country={countryItem}
              selected={
                selectedCountries[countryItem]
                  ? selectedCountries[countryItem]["dates"]["startdate"]
                  : ""
              }
              onChange={(newDate) => {
                setDate(newDate, countryItem, "startdate");
              }}
              placeholderText="YYYY-MM-DD"
              className="default-input"
              selectsEnd
            />
          </td>
          <td>
            <DatePicker
              dateFormat="yyyy-MM-dd"
              autoComplete="off"
              name={"enddate_" + countryItem}
              selected={
                selectedCountries[countryItem]
                  ? selectedCountries[countryItem]["dates"]["enddate"]
                  : ""
              }
              onChange={(newDate) => {
                setDate(newDate, countryItem, "enddate");
              }}
              placeholderText="YYYY-MM-DD"
              className="default-input"
              selectsEnd
            />
          </td>
        </tr>
      );
    });
  };

  const handleEmailSubmit = (email) => {
    setEmailErrorMessage('');
    removeEmailError()

    if (
      EMAIL_VALIDATION(email)
    ) {

      moveStepUp();
      setEmailToTest(email);

    } else {
      setEmailError()
    }
  };


  const handleCompanyNameSubmit = (email) => {
    removeCompanyNameError()

    if (
      email === undefined ? true : false
    ) {

      moveStepUp();
      setCompanyNameToTest(email);

    } else {
      setCompanyNameError()
    }
  };



  const handleDifferentEmailSubmit = (email) => {
    removeCompanyNameError()

    if (
      email === undefined ? true : false
    ) {

      moveStepUp();
      setDifferentEmailToTest(email);

    } else {
      setCompanyNameError()
    }
  };

  return (
    <div className="RegisterUserType">
      <Form
        onSubmit={onSubmit}
        render={({ handleSubmit, submitting, values }) => (
          <form onSubmit={handleSubmit} noValidate>
            {/* 1st step */}
            {(currentStep === 1 || currentStep === 2) && (
              <RegisterEmailComponent
                moveStepUp={moveStepUp}
                emailContent={FORM_FIELDS_USER_ONE.email}
                companyName={FORM_FIELDS_USER_ONE.companyName}
                contactEmail={FORM_FIELDS_USER_ONE.contactEmail}
                emailValidationStatus={emailIsValid}
                companyNameValidationStatus={companyNameIsValid}
                emailErrorMessage={emailErrorMessage}
                handleEmailSubmit={handleEmailSubmit}
                handleCompanyNameSubmit={handleCompanyNameSubmit}
                handleDifferentEmailSubmit={handleDifferentEmailSubmit}
                showCompanyName={handleCompanyNameSubmit}

                countries={countries}
                values={values}
              />
            )}

            {/* 2nd step */}
            {/* {currentStep === 3 && (
              // <RegisterProductDescriptionComponent
              //   required={CHECK_IF_REQUIRED}
              //   stepChange={moveStepUp}
              //   setRegistrationError={setRegistrationError}
              //   // setMoss={setMoss}
              //   values={values}
              //   countries={countries}
              //   SecondStepformContent={{
              //     // digitalGoods: FORM_FIELDS_USER_ONE.digitalGoods,
              //     vatIncluded: FORM_FIELDS_USER_ONE.vatIncluded,
              //     // countryOfDispatch: FORM_FIELDS_USER_ONE.countryOfDispatch,
              //   }}
              // />
            )} */}

            {/* 3rd step */}
            {currentStep === 3 &&
              (OBJECT_EMPTY(countries) ? (
                <div className="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
              ) : (
                <div className="RegisterCountrySelect registration-page-step">
                  <h3 className="registration-page-step__title">
                    Please select your current VAT registrations
                  </h3>
                  <div className="registration-page-step__country-select">
                    <div className="RegisterCountrySelect__continents-row">
                      {getContinents(values)}
                    </div>

                    <div className="RegisterCountrySelect__countries-table">
                      {getCountries()}
                    </div>
                  </div>
                  <div className="registration-page-step__button-wrapper">
                    <button
                      type="button"
                      disabled={Object.keys(selectedCountries).length === 0}
                      className="registration-input registration-input__button"
                      onClick={() => {
                        setShowModal(true);
                      }}
                    >
                      proceed
                    </button>
                  </div>

                  {/* modal part */}
                  <div
                    className={
                      "modal " +
                      (!showModal ? "hide " : "") +
                      (isLoading ? "loading " : "")
                    }
                  >
                    <div className="modal__content">
                      <div className="modal__top-row">
                        <button
                          type="button"
                          className='icon'
                          onClick={() => setShowModal(false)}
                        ></button>
                        <h1>Registration Dates</h1>
                      </div>

                      <div className="modal__table-wrapper">
                        <table className="modal__table">
                          <thead>
                            <tr>
                              <th>Region</th>
                              <th>Registration date *</th>
                              <th>De-registration date</th>
                            </tr>
                          </thead>

                          <tbody>{listSelectedCountriesModal()}</tbody>
                        </table>
                      </div>

                      <div className="modal_button">
                        
                        <button
                          type="submit"
                          className="registration-input registration-input__button"
                          disabled={datesSubmitDisabled}
                        >
                          Save & Finnish
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              ))}

            {currentStep === 4 && (
               <Redirect
                  to={{
                    pathname: "/user/provider",
                    state: { fromRegistration: true },
                  }}
               />
            )}
          </form>
        )}
      />
    </div>
  );
};
